import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { calculateDefaultUnit } from '../../../../../common/selectCurrencyUnit/slice'
import HighLightService from './service'

export const getHighLight = createAsyncThunk(
  'companyAnalysis/industryOverview/getHighLight',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const res = await HighLightService.getHighLight(params)

      if (res.success) {
        dispatch(
          calculateDefaultUnit({
            screen: SCREEN.INDUSTRY_OVERVIEW,
            getValues: () => [
              { value: res.data?.totalFDI, year: params.FiscalYear },
            ],
          }),
        )
        return res.data
      }

      return rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
